"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var onboard_common_1 = require("@sovryn/onboard-common");
var provider_1 = require("./provider");
var index_1 = require("./store/index");
var streams_1 = require("./streams");
var utils_1 = require("./utils");
var validation_1 = require("./validation");
function setChain(options) {
    return __awaiter(this, void 0, void 0, function () {
        var error, _a, wallets, chains, chainId, _b, chainNamespace, walletToSet, chainIdHex, chain, wallet, walletConnectedChain, error_1, code, switchChainModalClosed$, error_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    error = (0, validation_1.validateSetChainOptions)(options);
                    if (error) {
                        throw error;
                    }
                    _a = index_1.state.get(), wallets = _a.wallets, chains = _a.chains;
                    chainId = options.chainId, _b = options.chainNamespace, chainNamespace = _b === void 0 ? 'evm' : _b, walletToSet = options.wallet;
                    chainIdHex = (0, utils_1.toHexString)(chainId);
                    chain = chains.find(function (_a) {
                        var namespace = _a.namespace, id = _a.id;
                        return namespace === chainNamespace && id === chainIdHex;
                    });
                    if (!chain) {
                        throw new Error("Chain with chainId: ".concat(chainId, " and chainNamespace: ").concat(chainNamespace, " has not been set and must be added when Onboard is initialized."));
                    }
                    wallet = walletToSet
                        ? wallets.find(function (_a) {
                            var label = _a.label;
                            return label === walletToSet;
                        })
                        : wallets[0];
                    // validate a wallet is connected
                    if (!wallet) {
                        throw new Error(walletToSet
                            ? "Wallet with label ".concat(walletToSet, " is not connected")
                            : 'A wallet must be connected before a chain can be set');
                    }
                    walletConnectedChain = wallet.chains[0];
                    // check if wallet is already connected to chainId
                    if (walletConnectedChain.namespace === chainNamespace &&
                        walletConnectedChain.id === chainIdHex) {
                        return [2 /*return*/, true];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 9]);
                    return [4 /*yield*/, (0, provider_1.switchChain)(wallet.provider, chainIdHex)];
                case 2:
                    _c.sent();
                    return [2 /*return*/, true];
                case 3:
                    error_1 = _c.sent();
                    code = error_1.code;
                    switchChainModalClosed$ = streams_1.switchChainModal$.pipe((0, operators_1.filter)(function (x) { return x === null; }), (0, operators_1.map)(function () { return false; }));
                    if (!(code === onboard_common_1.ProviderRpcErrorCode.CHAIN_NOT_ADDED)) return [3 /*break*/, 8];
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 7, , 8]);
                    return [4 /*yield*/, (0, provider_1.addNewChain)(wallet.provider, chain)];
                case 5:
                    _c.sent();
                    return [4 /*yield*/, (0, provider_1.switchChain)(wallet.provider, chainIdHex)];
                case 6:
                    _c.sent();
                    return [2 /*return*/, true];
                case 7:
                    error_2 = _c.sent();
                    // display notification to user to switch chain
                    streams_1.switchChainModal$.next({ chain: chain });
                    return [2 /*return*/, (0, rxjs_1.firstValueFrom)(switchChainModalClosed$)];
                case 8:
                    if (code === onboard_common_1.ProviderRpcErrorCode.UNSUPPORTED_METHOD) {
                        // method not supported
                        streams_1.switchChainModal$.next({ chain: chain });
                        return [2 /*return*/, (0, rxjs_1.firstValueFrom)(switchChainModalClosed$)];
                    }
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/, false];
            }
        });
    });
}
exports["default"] = setChain;
